/**
 *
 *
 *
 *
 *
 *
 *
 */
import { useSyncExporter } from "../common/useSyncExporter.js";
import { toggleSync, type ToggleSync } from "../globals/toggle.js";

export type { GetToggleResult } from "../lib/toggle/get.js";

/*                                                                     */
export type Toggle = ToggleSync;

export {
  /*                                                                     */
  toggleSync as toggle,
};

const asExp = useSyncExporter(({ o_util }) => o_util.toggle);

/**
 *
 *
 *
 *
 *
 */
export const get: ToggleSync["get"] = asExp("get");

/**
 *
 *
 *
 *
 */
export const getToggle: ToggleSync["getToggle"] = asExp("getToggle");
